import React, { Component } from 'react';
import { components } from '@kurtosys/ksys-app-components';
import { inject, observer } from 'mobx-react';

import Header from '../Header/Header.js';
import Question from '../Question/Question.js';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.js';

import BackButton from './styledComponents/BackButton.js';
import BackButtonWrapper from './styledComponents/BackButtonWrapper.js';
import ButtonWrapper from './styledComponents/ButtonWrapper.js';
import FinishButton from './styledComponents/FinishButton.js';
import ForwardButton from './styledComponents/ForwardButton.js';
import ForwardButtonWrapper from './styledComponents/ForwardButtonWrapper.js';
import Wrapper from './styledComponents/Wrapper.js';
import { IQuestionWizardProps, IQuestionWizardState } from './models';

const ProgressIndicator = components.base.ProgressIndicator.ProgressIndicator;
class RawQuestionWizard extends Component<IQuestionWizardProps, IQuestionWizardState> {
	static configurationKey = 'questionWizard' as const;
	static styleKey = 'questionWizard' as const;
	constructor(props: IQuestionWizardProps) {
		super(props);
	}
	render() {
		const { className, questionWizardStore } = this.props;

		if (!questionWizardStore || !questionWizardStore.hasQuestions) {
			return null;
		}

		const { progressIndicatorProps, backButtonProps, forwardButtonProps, finishButtonProps } = questionWizardStore;

		return (
			<Wrapper className={className}>
				<ProgressIndicator {...progressIndicatorProps} />
				<Header />
				<Question />
				<ButtonWrapper>
					<BackButtonWrapper>
						<BackButton {...backButtonProps} />
					</BackButtonWrapper>
					<ForwardButtonWrapper>
						<ForwardButton {...forwardButtonProps} />
						<FinishButton {...finishButtonProps} />
					</ForwardButtonWrapper>
				</ButtonWrapper>
			</Wrapper>
		);
	}
}

export const QuestionWizard = inject('appStore', 'questionWizardStore')(observer(RawQuestionWizard));
export default InjectedStyledComponent(QuestionWizard, 'questionWizard');
